import React, { useState, useEffect } from "react";
import { Container } from "semantic-ui-react";
import classnames from "classnames";
import { useWindowDimensions } from "ceco-hooks";
import Menu from "../Menu";
import Sidebar from "../Sidebar";
import menuEntries from "../../../router/menuEntries";
import { logout } from "../../../api/api";
import "./Layout.scss";

export default function Layout(props) {
  const { children, router, roleMode } = props;
  const { windowWidth } = useWindowDimensions();
  const [menuExpanded, setMenuExpanded] = useState(windowWidth >= 768.99);
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [sidebarProps, setSidebarProps] = useState(false);

  const auth = {
    user: {
      username: sessionStorage.getItem('username')
    }
  }
  const isRecipePage = window.location.href.indexOf('recipes') !== -1
  
  useEffect(() => {
    if (!isRecipePage) {
      setSidebarExpanded(false)
    }
  }, [isRecipePage]);

  return (
    <Container fluid className="dashboard-layout">
      <div className="bgbouncing" />
      <Menu
        auth={auth}
        roleMode={roleMode}
        expanded={menuExpanded}
        setExpanded={setMenuExpanded}
        onChange={setMenuExpanded}
        routes={menuEntries}
        onLogoutClick={() =>
          logout().then(() => {
            router.push("/login");
          })
        }
        {...props}
      />
      <div
        className={classnames("dashboard-layout__content", {
          menuExpanded,
          sidebarExpanded: sidebarExpanded && !sidebarProps.isFixed,
        })}
      >
        {children !== undefined &&
          React.cloneElement(React.Children.only(children), {
            menuExpanded,
            setMenuExpanded,
            sidebarExpanded,
            setSidebarExpanded,
            setSidebarProps,
          })}
      </div>
      <Sidebar
        expanded={sidebarExpanded}
        setExpanded={setSidebarExpanded}
        {...sidebarProps}
      />
    </Container>
  );
}
